import React from 'react';
import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';
import { StoreIdentifierName } from 'types';
import RecentlySearched from './RecentlySearched';
import './PreSAYTSuggestions.scss';

type PreSAYTSuggestionsProps = {
  storeIdentifierName: StoreIdentifierName;
  handleShowPreSayt: (value: boolean) => void;
};

const PreSAYTSuggestions = ({
  storeIdentifierName,
  handleShowPreSayt,
}: PreSAYTSuggestionsProps) => {
  return (
    <div className="dsg-search-presayt-container">
      <ErrorBoundaryWithLogger componentId="PreSAYTSuggestions-RecentlySearched">
        <RecentlySearched
          storeIdentifierName={storeIdentifierName}
          handleShowPreSayt={handleShowPreSayt}
        />
      </ErrorBoundaryWithLogger>
    </div>
  );
};

export default PreSAYTSuggestions;
